import styled from '@emotion/styled'
import { Box, Fab, IconButton, Paper, TextField } from '@mui/material'

export const ChatToggle = styled(Fab)`
    position: fixed;
    bottom: 25px;
    right: 25px;
    z-index: 1000;
`

export const ChatPopup = styled(Paper)`
    position: fixed;
    bottom: 100px;
    right: 25px;
    z-index: 1000;

    display: flex;
    flex-direction: column;
    width: 360px;
    height: 600px;
    border-radius: 10px;
    overflow: hidden;
`

export const ChatHeader = styled(Box)`
    display: flex;
    align-items: center;
    padding: 20px 16px;
    border-bottom: 1px solid #CCCCCC;
    color: #1A1A1A;
    gap: 8px;
`

export const HeaderCloseButton = styled(IconButton)`
    margin-left: auto;
    padding: 4px;
`

export const HeaderTitle = styled('div')`
    font-size: 1rem;
    font-weight: 500;
    line-height: 24px;
`

export const MessageList = styled(Box)`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 16px;
    padding: 16px;
    overflow-y: auto;
`

const MsgBubbleBase = styled('div')`
    border-radius: 8px;
    padding: 8px 12px;
    max-width: 88%;
    white-space: pre-wrap;
    word-break: break-word;
        font-size: 0.875rem;
    line-height: 1.43;
`

export const UserMsgBubble = styled(MsgBubbleBase)`
    background-color: #EBF3FF;
    color: #1A1A1A;
    align-self: flex-end;
    border-bottom-right-radius: 0;
`

export const AgentMsgBubble = styled(MsgBubbleBase)<{ $isError?: boolean }>`
    background-color: ${({ $isError }) => ($isError ? '#fde7e9' : '#f2f2f2')};
    color: ${({ $isError }) => ($isError ? '#a4262c' : '#1A1A1A')};
    align-self: flex-start;
    border-bottom-left-radius: 0;
`

export const ThinkingBox = styled(Box)`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const ThinkingText = styled('div')`
    color: #666666;
    font-size: 0.875rem;
    line-height: 1.43;
    font-style: italic;
`

export const InputRow = styled('form')`
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 6px;
    border-top: 1px solid #CCCCCC;
`

export const InputField = styled(TextField)`
    flex: 1;
    padding-right: 0 !important;
`

export const SendButton = styled(IconButton)`
    border-radius: 4px;
    color: #0C66E1;
`

export const AiDisclaimer = styled.div`
    color: #666666;
    font-size: 12px;
    text-align: center;
`
